module.exports = __webpack_public_path__ + "assets/img/notification.0fae77db.gif";